<div>
	<div class="modal-header">
		<h4 class="modal-title">Lancer le dossier {{folderName}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<p>Etes-vous sûre de vouloir lancer le projet ?</p>
        <p>Pour démarrer le projet, cliquez sur le bouton "Lancer".</p>
        <p>Pour annuler l'action, cliquez sur le bouton "Annuler".</p>
    </div>

    <div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="submit" class="btn btn-primary" [disabled]="!enableAction" (click)="save()">{{buttonText}}</button>
	</div>
</div>